import {
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td
} from '@chakra-ui/react';
import React from 'react';
import { MaintenanceModalDispLabel } from '../../../atoms/MaintenanceModalDispLabel';
import { chooseDataStateType } from '../../../molecules/MaintenanceModalDispLabels';

export interface SettingsType {
  item_no: number;
  item_name: string;
  value: string;
  view_int: number;
  view_digit: number;
  str_length_max: number;
  value_min: number;
  type: string;
}

interface props {
  SettingsDatas: SettingsType[] | null | undefined;
  onOpen: () => void;
  setChooseData: (data: chooseDataStateType) => void;
}

export const MaintenanceSettingsTable: React.FC<props> = (props) => {
  const { SettingsDatas, onOpen, setChooseData } = props;
  return (
    <>
      <TableContainer
        position='absolute'
        h='100%'
        w='97%'
        ml={5}
        overflowY='auto'
        gridRow='2/3'
        overflowX='unset'
      >
        <Table variant='simple'>
          <Thead borderWidth='1px' position='sticky' top={0} zIndex='docked'>
            <Tr bg='gray.800'>
              <Th textAlign='center' borderWidth='1px' color='white'>
                設定項目
              </Th>
              <Th textAlign='center' borderWidth='1px' color='white'>
                値
              </Th>
              <Th textAlign='center' borderWidth='1px' color='white'></Th>
            </Tr>
          </Thead>
          <Tbody>
            {SettingsDatas?.map((data, i) => {
              return (
                <Tr key={'setting_' + i}>
                  <Td>{data.item_name}</Td>
                  <Td>{data.value}</Td>
                  <Td textAlign='center'>
                    <MaintenanceModalDispLabel
                      data={{ type: 'settings', settings: data }}
                      setChooseData={setChooseData}
                      onOpen={onOpen}
                      dispString={'編集'}
                    />
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};
